import { render, staticRenderFns } from "./EasyDataTemplate.vue?vue&type=template&id=ab0fdffc&scoped=true"
import script from "./EasyDataTemplate.vue?vue&type=script&lang=js"
export * from "./EasyDataTemplate.vue?vue&type=script&lang=js"
import style0 from "./EasyDataTemplate.vue?vue&type=style&index=0&id=ab0fdffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0fdffc",
  null
  
)

export default component.exports